import React, { FC, PropsWithChildren } from 'react';
import { Redirect } from 'expo-router';
import { concatPath } from '../../utils/links/concatPath';
import { dashboardKey, dashboardStackKey, privateKey } from '../../constants/routeKeys';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/useStores';

export const FaceScanGuard: FC<PropsWithChildren> = observer(({ children }) => {
  const { user } = useStores();

  if (user?.company?.hasAccessToFaceScan === false) {
    return <Redirect href={concatPath([privateKey, dashboardStackKey, dashboardKey], -1) as string} />;
  }

  return <>{children}</>;
});
